import { useCallback, useEffect } from 'react'
import { debounce } from 'lodash';
import { useLayoutEffect } from 'react';

const useCoords = (menu,modal = null, data = null) => {
    const SPACING = 15
    const GAP = modal ? 5 : 0

    const setMenuPosition  = useCallback(() => {
        if (!menu.current){
            return
        }
        else{
            menu.current.style.maxHeight = ""
            let btn = modal === "tag-filter-menu" ? document.getElementById("tag-filter-btn") : menu.current.previousElementSibling
            let btnCoords = btn.getBoundingClientRect()
            let height = menu.current.offsetHeight

            if (btnCoords.bottom + height + SPACING > window.innerHeight){
                let aboveSpace = btnCoords.top
                let belowSpace = window.innerHeight - btnCoords.bottom
                if (belowSpace > aboveSpace){
                if (modal === "tag-filter-menu"){
                    menu.current.classList.remove("above-menu")
                    btn.classList.remove("above-btn")
                }
                    menu.current.style.top = `${btnCoords.bottom + (modal === "tag-filter-menu" ? 0 : GAP)}px`
                    menu.current.style.bottom = ""
                    menu.current.style.maxHeight = `${window.innerHeight - btnCoords.bottom - GAP - SPACING}px`
                }
                else{
                    if (modal === "tag-filter-menu"){
                        menu.current.classList.add("above-menu")
                        btn.classList.add("above-btn")
                    }
                    menu.current.style.bottom = `${window.innerHeight - btnCoords.top + (modal === "tag-filter-menu" ? 0 : GAP)}px`
                    menu.current.style.top = ""
                    menu.current.style.maxHeight = `${btnCoords.top - GAP}px`
                }
            }
            else{
                if (modal === "tag-filter-menu"){
                    menu.current.classList.remove("above-menu")
                    btn.classList.remove("above-btn")
                }
                menu.current.style.top = `${btnCoords.bottom + (modal === "tag-filter-menu" ? 0 : GAP)}px`
                menu.current.style.maxHeight = `${btnCoords.bottom - GAP - SPACING}px`
                menu.current.style.bottom = ""
            }
            if (modal === "add-note" || modal === "edit-note" || modal === "color-menu"){
                const menuWidth = menu.current.offsetWidth
                const centerX = btnCoords.left + (btnCoords.width / 2) - (menuWidth / 2)
                const maxLeft = window.innerWidth - menuWidth - 5
                const finalLeft = Math.min(Math.max(centerX, 5), maxLeft)
                menu.current.style.left = `${finalLeft}px`
            }
            else{
                menu.current.style.width = `${btnCoords.width}px`
                menu.current.style.left = `${btnCoords.left}px`
            }
            
        }
    },[menu,GAP,modal])

    useLayoutEffect(()=>{
        if (menu.current){
            setMenuPosition()
        }
        const handleResize = debounce(setMenuPosition, 200);
        window.addEventListener("resize",handleResize)
        return () => {
            window.removeEventListener("resize",handleResize)
        }
    },[menu,setMenuPosition])

    useEffect(()=>{
        setMenuPosition()
    },[data,setMenuPosition])

    return 
}

export default useCoords